/**
 * Work session labels (AGENT-STATUS-1), shared by the agent cards and the project panel.
 */

import type { WorkSession } from '../../types/agent';

export const NO_PROJECT_LABEL = 'No project';

/** The project's name; an id the portal does not know shows as itself; none shows as "No project". */
export function projectLabel(session: Pick<WorkSession, 'projectId' | 'projectName'>): string {
  return session.projectName ?? session.projectId ?? NO_PROJECT_LABEL;
}

/** "2:14 PM" today, "Oct 20, 2:14 PM" on another day. */
export function formatSessionTime(iso: string, now = new Date()): string {
  const when = new Date(iso);
  if (Number.isNaN(when.getTime())) return '';
  const time = when.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return when.toDateString() === now.toDateString()
    ? time
    : `${when.toLocaleDateString([], { month: 'short', day: 'numeric' })}, ${time}`;
}

/** "No update since 2:14 PM" for a quiet session; null otherwise. */
export function quietNote(session: Pick<WorkSession, 'quiet' | 'updatedAt'>): string | null {
  return session.quiet ? `No update since ${formatSessionTime(session.updatedAt)}` : null;
}

export const SESSION_STATE_STYLE: Record<WorkSession['status'], { dot: string; label: string }> = {
  working: { dot: 'bg-green-500', label: 'Working' },
  waiting: { dot: 'bg-yellow-500', label: 'Waiting' },
};
